module.exports = __webpack_public_path__ + "static/media/BANANA-TWT-BNB.ccc7a198.svg";